import { TUser } from '../../types/user';

const defaultState: TUser = null;

export function userReducer(state: TUser = defaultState) {
  return state;
}
